import { useEffect, useRef } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { queryKeys } from '../queryKeys';
import type { SubmissionResult } from '@/features/ProblemWorkspace/TestCasePanel';

/**
 * When a submission resolves to AC, refresh the caches that show solved state:
 * the lesson the problem was opened from (if any) and the /problems checkmarks.
 * Fires once per submission id so re-renders don't re-invalidate.
 */
export function useInvalidateOnSolved(result: SubmissionResult | null, topicId?: string) {
  const qc = useQueryClient();
  const handledRef = useRef<string | null>(null);

  useEffect(() => {
    if (!result || result.verdict !== 'AC') return;
    if (handledRef.current === result.submission_id) return;
    handledRef.current = result.submission_id;

    if (topicId) {
      qc.invalidateQueries({ queryKey: queryKeys.lms.topicDetail(topicId) });
    }
    qc.invalidateQueries({ queryKey: queryKeys.problems.stats() });
  }, [result, topicId, qc]);
}
